import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import PlanTable from "../../components/ui/planTable/PlanTable";
import Footer from "../../components/Footer.js/Footer";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "./Host.css";
import PopUp from "../../components/PopUp/PopUp";

const Host = () => {
  const { name } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `https://api.spadserver.com/api/product/${name}`
        );
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const result = await response.json();
        console.log("API Result:", result); // Log the result for debugging
        setData(result.data);
        setError(null);
        document.title = result.data?.meta_title || "Default Title";
      } catch (error) {
        console.error(`Error fetching data: ${error.message}`); // Log error for debugging
        setError(`Error fetching data: ${error.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [name]);

  if (loading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!data) {
    return <div>No data available</div>;
  }

  const uniqueProducts = data.products
    .filter(
      (product, index, self) =>
        index === self.findIndex((p) => p.title === product.title)
    )
    .slice(0, 4);

  return (
    <div>
      <div className="container mx-auto">
        <div
          className="grid lg:grid-cols-2 md:grid-cols-1 gap-3 mx-auto"
          style={{ width: "80%" }}
        >
          <div className="text-right">
            <p className="lg:text-[26px] sm:text-[12px] sm:font-bold text-white">
              {data.title}
            </p>
            <div
              className="lg:mt-24 mt-4 mb-6 text-white text-justify text-[13px] lg:text-[15px] nb-4"
              dangerouslySetInnerHTML={{ __html: data.description }}
            ></div>
          </div>
          <div className="lg:text-left md:text-center">
            <img
              src={`https://admin.spadserver.com/storage/${data.photo.path}`}
              alt="Host"
              className="w-full max-w-md h-auto inline-block"
            />
          </div>
        </div>
      </div>

      <div className="planName mt-16">
        <p className="text-white lg:text-[26px] md:text-[20px] sm:text-[16px] text-center">
          {data.meta_title}
        </p>
        <PlanTable products={uniqueProducts} />
      </div>
      <div
        className="textSiteDesign text-white flex flex-col items-center justify-center p-4 mt-10 mb-10"
        style={{
          backgroundColor: "rgba(128, 128, 128, 0.3)",
          width: "100vw",
          marginLeft: "calc(-50vw + 50%)",
          marginRight: "calc(-50vw + 50%)",
        }}
      >
        <p className="text-center mt-10 text-xl font-bold">طراحی سایت</p>
        <div className="text-md mt-8 mb-8 px-4 sm:mt-10 sm:mb-10 sm:px-6 md:mt-12 md:mb-12 md:px-8 lg:mt-14 lg:mb-14 lg:px-10 xl:mt-16 xl:mb-16 xl:px-12 text-justify lg:text-[15px]">
          <p>
            با خدمات طراحی سایت اسپاد سرور، کسب‌وکار آنلاین خود را به سطح جدیدی
            ببرید. ما با استفاده از آخرین تکنولوژی‌ها و طراحی‌های مدرن، وب‌سایتی
            منحصربه‌فرد و حرفه‌ای برای شما ایجاد می‌کنیم.
          </p>
        </div>

        <div className="groupButtons xl:w-[450px] md:w-[200px]">
          <img src="/images/groupButtons.png" alt="" />
        </div>
        <div className="mainPageRequest text-center mt-4">
          <a
            href="https://crm.spadserver.com/contact.php"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="bg-red-400 p-3 w-40 rounded-[30px] mt-10 request">
              ارسال درخواست
            </button>
          </a>
        </div>
      </div>

      <PopUp />
    </div>
  );
};

export default Host;
